import { render, staticRenderFns } from "./driver.vue?vue&type=template&id=c19015e2&scoped=true"
import script from "./driver.vue?vue&type=script&lang=js"
export * from "./driver.vue?vue&type=script&lang=js"
import style0 from "./driver.vue?vue&type=style&index=0&id=c19015e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19015e2",
  null
  
)

export default component.exports